import { Button, Result } from 'antd';
import { useHistory } from 'react-router';


const UserGuidePage = () => {
  const history = useHistory();
  return (
    <Result
      title="User Guide was opened in a new tab."
      extra={
        <Button type="primary" key="home" onClick={() => history.push('/')}>
          Go Home
        </Button>
      }
    />
  );
};

export default UserGuidePage;
